import React, {useRef, useState} from 'react';
import "../task-creator.module.css"
const ContextMenu = ({element,close,changeText,type}) => {
    const submenuRef = useRef(null); // Ссылка на новое меню
    const [isSubmenuOpen, setSubmenuOpen] = useState(false); // Состояние открытия нового меню
    document.addEventListener("click", () => {
        close()
    })
    function selectAll(e){
        e.target.select()
    }
    function copy(){
        navigator.clipboard.writeText(window.getSelection().toString()).then()
    }
    function paste(e){
        let firstText = e.target.value.slice(0, e.target.selectionStart);
        let secondText = e.target.value.slice(e.target.selectionEnd, e.target.value.length);
        navigator.clipboard.readText().then((data) => {
            e.target.value=firstText + data + secondText;
            changeText(e)
        })
    }
    function makePass(e){
        if(e.target !== undefined && e.target.selectionStart !== undefined && e.target.selectionEnd !== undefined) {
            let str = e.target.value.slice(0, e.target.selectionStart) +
                '[?' + e.target.value.slice(e.target.selectionStart, e.target.selectionEnd) + '?]' +
                e.target.value.slice(e.target.selectionEnd, e.target.value.length);
                e.target.value=str;
            changeText(e);
        }
    }
    function makeInclined(e){
        if(e.target !== undefined && e.target.selectionStart !== undefined && e.target.selectionEnd !== undefined) {
            let str = e.target.value.slice(0, e.target.selectionStart) +
                '[/' + e.target.value.slice(e.target.selectionStart, e.target.selectionEnd) + '/]' +
                e.target.value.slice(e.target.selectionEnd, e.target.value.length);
            e.target.value=str;
            changeText(e);
        }
    }
    function makeUnderlined(e){
        if(e.target !== undefined && e.target.selectionStart !== undefined && e.target.selectionEnd !== undefined) {
            let str = e.target.value.slice(0, e.target.selectionStart) +
                '[_' + e.target.value.slice(e.target.selectionStart, e.target.selectionEnd) + '_]' +
                e.target.value.slice(e.target.selectionEnd, e.target.value.length);
            e.target.value=str;
            changeText(e);
        }
    }
    function makeFatty(e){
        if(e.target !== undefined && e.target.selectionStart !== undefined && e.target.selectionEnd !== undefined) {
            let str = e.target.value.slice(0, e.target.selectionStart) +
                '[!' + e.target.value.slice(e.target.selectionStart, e.target.selectionEnd) + '!]' +
                e.target.value.slice(e.target.selectionEnd, e.target.value.length);
            e.target.value=str;
            changeText(e);
        }
    }

    function paragraph(e) {
        if(e.target !== undefined && e.target.selectionStart !== undefined && e.target.selectionEnd !== undefined) {
            let start = e.target.selectionStart
            let strStart =''
             if(e.target.value[start-1]==='\n' ||e.target.value[start-1]===undefined){
                 strStart+='\t';
             }
             else{
                 strStart+='\n\t';
             }
            let str = e.target.value.slice(0, e.target.selectionStart) +
                strStart + e.target.value.slice(e.target.selectionStart, e.target.selectionEnd) + '\n' +
                e.target.value.slice(e.target.selectionEnd, e.target.value.length);
            e.target.value=str;
            changeText(e);
        }
    }
    function includeSelect(e){
        if(e.target !== undefined && e.target.selectionStart !== undefined && e.target.selectionEnd !== undefined) {
            let str = e.target.value.slice(0, e.target.selectionStart) +
                '{{' + e.target.value.slice(e.target.selectionStart, e.target.selectionEnd) + '}}' +
                e.target.value.slice(e.target.selectionEnd, e.target.value.length);
            e.target.value=str;
            changeText(e);
        }
    }
    function pastFormula(formula,e) {
        let firstText = e.target.value.slice(0, e.target.selectionStart);
        let secondText = e.target.value.slice(e.target.selectionEnd, e.target.value.length);
        e.target.value = firstText + formula + secondText;
        changeText(e)
    }
    function handleSubmenuOpen() {
        setSubmenuOpen(true);
    }

    function handleSubmenuClose() {
        setSubmenuOpen(false);
    }

    const submenuStyle = {
        position: 'fixed',
        top: element.clientY+100,
        left: element.clientX+170,
    };

    return (
            <div className="taskcr-txt-context" style={{ position: 'fixed', top: element.clientY, left: element.clientX }}>
                <div className="taskcr-txt-context-item"><button onClick={() => { paragraph(element) }}>абзац</button></div>
                <div className="taskcr-txt-context-item"><button onClick={() => { includeSelect(element) }}> разрешить выделение</button></div>
                <hr/>
                <div className="taskcr-txt-context-item"><button onClick={() => { selectAll(element) }}>выделить всё</button></div>
                <hr/>
                <div className="taskcr-txt-context-item"><button onClick={() => { copy() }}>копировать</button></div>
                <div className="taskcr-txt-context-item"><button onClick={() => { paste(element) }}>вставить</button></div>
                <hr/>
                {type===6 &&
                <div className="taskcr-txt-context-item"><button onClick={() => { makePass(element) }}>сделать пропуск</button></div>}
                <div className="taskcr-txt-context-item"><button onClick={() => { makeUnderlined(element) }}>подчеркнутый</button></div>
                <div className="taskcr-txt-context-item"><button onClick={() => { makeInclined(element) }}>наклонный</button></div>
                <div className="taskcr-txt-context-item"><button onClick={() => { makeFatty(element) }}>жирный</button></div>
                <div
                    className="taskcr-txt-context-item"
                    onMouseOver={handleSubmenuOpen}
                    onMouseLeave={handleSubmenuClose}
                >
                    <button>Формулы</button>
                    {isSubmenuOpen && (
                        <div ref={submenuRef} style={submenuStyle} className="taskcr-txt-context">
                            <div style={{display:'flex',justifyContent: 'space-around'}}>
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('√(',element)}><button>&#8730;</button></div>  {/* корень */}
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('∞',element)}><button>&#8734;</button></div>  {/* бесконечность */}
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('°',element)}><button>&#176;</button></div>  {/* градус */}
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('∑',element)}><button>&#8721;</button></div>  {/* сумма */}
                            </div>
                            <hr/>
                            <div style={{display:'flex',justifyContent: 'space-around'}}>
                                <div>
                                    <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('>',element)}><button>&#62;</button></div>  {/* больше */}
                                    <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('≥',element)}><button>&#8805;</button></div>  {/* больше или равно */}
                                </div>
                                <div>
                                    <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('<',element)}><button>&#60;</button></div>  {/* меньше */}
                                    <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('≤',element)}><button>&#8804;</button></div>  {/* меньше или равно */}
                                </div>
                                <div>
                                    <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('≈',element)}><button>&#8776;</button></div>  {/* примерно равно */}
                                    <div  className="taskcr-txt-context-item" onClick={()=>pastFormula('±',element)}><button>&#177;</button></div>  {/* плюс минус */}
                                </div>
                            </div>
                            <hr/>
                            <div  style={{display:'flex',justifyContent: 'space-around'}}>
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('²',element)}><button>x&sup2;</button></div>  {/* х во втрой */}
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('³',element)}><button>x&sup3;</button></div>  {/* х в третей */}
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('^(',element)}><button>x^n</button></div>  {/* х во n */}
                            </div>
                            <hr/>
                            <div style={{display:'flex',justifyContent: 'space-around'}}>
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('sin(',element)}> <button>sin</button></div>  {/* синус */}
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('cos(',element)}><button>cos</button></div>  {/* косинус */}
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('tg(',element)}><button>tg</button></div>  {/* тангенс*/}
                                <div className="taskcr-txt-context-item" onClick={()=>pastFormula('ctg(',element)}><button>ctg</button></div>  {/* котангенс */}
                            </div>
                            <hr/>
                            <div className="taskcr-txt-context-item" onClick={()=>pastFormula('π',element)}><button>&pi;</button></div>  {/* пи */}

                        </div>
                    )}
                </div>
            </div>
    );
};

export default ContextMenu;


